import React, { forwardRef, memo } from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';

const RadioButton = forwardRef(
  (
    { labelText, labelPosition, hasLabel, onChange, name, id, value, checked },
    ref,
  ) => (
    <S.RadioContainer position={labelPosition}>
      <S.Radio
        onChange={onChange}
        ref={ref}
        name={name}
        id={id}
        value={value}
        checked={checked}
      />
      <S.RadioButton className="RadioButton" htmlFor={id} />
      {hasLabel && (
        <S.Label position={labelPosition} htmlFor={id}>
          {labelText}
        </S.Label>
      )}
    </S.RadioContainer>
  ),
);

export default memo(RadioButton);

RadioButton.defaultProps = {
  labelText: '',
  labelPosition: 'right',
  hasLabel: false,
  onChange: () => {},
};

RadioButton.propTypes = {
  labelText: PropTypes.string,
  labelPosition: PropTypes.string,
  hasLabel: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  checked: PropTypes.bool.isRequired,
};
